import React from 'react';
import ATMPageHeader from 'src/components/UI/atoms/ATMPageHeader/ATMPageHeader';
import ATMPagination from 'src/components/UI/atoms/ATMPagination/ATMPagination';
import ATMTable, {
  columnTypes,
} from 'src/components/UI/atoms/ATMTable/ATMTable';
import SideNavLayout from 'src/components/layouts/SideNavLayout/SideNavLayout';
import { isCheckActionsPermission } from 'src/helpers/userAccessFun';
import { UserModuleActionTypes, UserModuleNameTypes } from 'src/models/userAccess/UserAccess.model';

type Props = {
  columns: columnTypes[];
  onAddNew:()=>void ;
  rows: any[];
  paginationProps: {
    isTableLoading: boolean;
    totalItems: number;
    page: number;
    rowsPerPage: number;
    searchValue: string;
    setPage: (newPage: number) => void;
    setRowsPerPage: (newLimit: number) => void;
    setSearchValue: (newValue: string) => void;
  };
};

const AssetsListing = ({
  columns,
  onAddNew ,
  rows,
  paginationProps: {
    isTableLoading,
    totalItems,
    page,
    rowsPerPage,
    searchValue,
    setPage,
    setRowsPerPage,
    setSearchValue,
  },
}: Props) => {
  return (
    <SideNavLayout>
      <div className='flex flex-col  p-4'>
        {/* Page Header */}
        <div >
          <ATMPageHeader
            pageTitle='Assets'
            searchValue={searchValue}
            onSearchChange={setSearchValue}
            hideAddButton={
              !isCheckActionsPermission({
                moduleName: UserModuleNameTypes.ASSETS,
                actionName: UserModuleActionTypes.ADD,
              })
            }
            buttonProps={{
              btnName: 'Add New',
              onClick: onAddNew 
            }}
          />
        </div>

        {/* Table */}
        <div className='flex-1 overflow-auto flex flex-col'>
            <ATMTable
            rows ={rows}
              columns={columns}
              rowExtraClasses={() => 'min-h-[40px]'}
              isLoading={isTableLoading}
            />
        </div>

        <div className='py-2'>
            <ATMPagination
              page={page}
              rowsPerPage={rowsPerPage}
              onPageChange={setPage}
              onRowsPerPageChange={setRowsPerPage}
              rowCount={totalItems}
              rows={rows}
            />
          </div>
      </div>
    </SideNavLayout>
  );
};

export default AssetsListing;